import { images } from './images';

export const caseStudyCategories = ['Tous', 'Achats', 'Supply chain', 'Organisation'];

export const caseStudies = [
  {
    slug: 'eti-industrielle-achats-directs',
    client: 'ETI industrielle · 450 salariés',
    sector: 'Industrie manufacturière',
    category: 'Achats',
    title: 'Renégociation des achats directs d’un équipementier mécanique',
    challenge:
      'Hausse brutale des prix matières, contrats non indexés et forte dépendance à trois fournisseurs historiques.',
    actions: [
      'Analyse des dépenses sur 4 ans et 1 200 références',
      'Mise en concurrence de 28 fournisseurs européens',
      'Contrats indexés sur les cours matières',
    ],
    results: [
      { value: '−14 %', label: 'sur les achats directs' },
      { value: '1,8 M€', label: 'd’économies annuelles' },
    ],
    duration: '6 mois',
    image: images.meeting,
  },
  {
    slug: 'distributeur-stocks',
    client: 'Distributeur spécialisé · 60 points de vente',
    sector: 'Distribution & retail',
    category: 'Supply chain',
    title: 'Refonte des approvisionnements et réduction des stocks',
    challenge: 'Ruptures fréquentes en magasin malgré un entrepôt saturé et un stock en hausse de 25 % en deux ans.',
    actions: [
      'Segmentation ABC/XYZ du catalogue',
      'Nouveaux paramètres de réapprovisionnement',
      'Rituel S&OP mensuel avec les équipes commerce',
    ],
    results: [
      { value: '−32 %', label: 'de stock dormant' },
      { value: '98 %', label: 'de taux de service' },
    ],
    duration: '8 mois',
    image: images.warehouse,
  },
  {
    slug: 'groupe-services-organisation',
    client: 'Groupe de services · 3 filiales',
    sector: 'Services & tertiaire',
    category: 'Organisation',
    title: 'Création d’une fonction achats groupe',
    challenge: 'Achats éclatés entre filiales, aucune visibilité sur les dépenses et des processus de validation trop longs.',
    actions: [
      'Organisation cible et fiches de poste',
      'Processus Procure-to-Pay unifié',
      'Tableau de bord mensuel des dépenses',
    ],
    results: [
      { value: '÷2', label: 'délais de commande' },
      { value: '85 %', label: 'des dépenses sous contrat' },
    ],
    duration: '9 mois',
    image: images.hero,
  },
  {
    slug: 'agro-sourcing',
    client: 'PME agroalimentaire · export',
    sector: 'Agroalimentaire',
    category: 'Achats',
    title: 'Sécurisation du sourcing emballages',
    challenge: 'Un fournisseur unique d’emballages en difficulté, menaçant la continuité de production.',
    actions: ['Qualification de 2 fournisseurs alternatifs', 'Double sourcing contractualisé', 'Stock de sécurité ajusté'],
    results: [
      { value: '0', label: 'arrêt de production' },
      { value: '−9 %', label: 'sur le coût emballages' },
    ],
    duration: '4 mois',
    image: images.port,
  },
];
